import request from '@/utils/request'

export function logList(data) {
    return request({
        url: '/acode/api/log/list',
        method: 'post',
        data
    })
}

export function getAutoStatus(params) {
    return request({
        url: '/acode/api/admin/selectAutoReview',
        method: 'get',
        params
    })
}

export function getSysConfig(params) {
    return request({
        url: '/acode/api/sys/config/query',
        method: 'get',
        params
    })
}
export function changeSysConfig(data) {
    return request({
        url: '/acode/api/sys/config/query',
        method: 'put',
        data
    })
}
export function sysConfigUpdate(data) {
    return request({
        url: '/acode/api/sys/config/update',
        method: 'put',
        data
    })
}
export function getSysConfigById(params) {
    return request({
        url: '/acode/api/sys/config/getById',
        method: 'get',
        params
    })
}

export function changeAutoStatus(params) {
    return request({
        url: '/acode/api/admin/updateAutoReview',
        method: 'get',
        params
    })
}
export function addRole(data) {
    return request({
        url: '/acode/api/sys/role/add',
        method: 'post',
        data
    })
}
export function roleList(data) {
    return request({
        url: '/acode/api/sys/role/query',
        method: 'post',
        data
    })
}
export function deleteRole(data) {
    return request({
        url: `/acode/api/sys/role/delete`,
        method: 'delete',
        params: data
    })
}
export function updateRole(data) {
    return request({
        url: '/acode/api/sys/role/update',
        method: 'post',
        data
    })
}
export function getRole(params) {
    return request({
        url: '/acode/api/sys/role/get',
        method: 'get',
        params
    })
}
export function addUser(data) {
    return request({
        url: '/acode/api/sys/user/add',
        method: 'post',
        data
    })
}
export function userList(data) {
    return request({
        url: '/acode/api/sys/user/list',
        method: 'post',
        data
    })
}
export function deleteUser(data) {
    return request({
        url: `/acode/api/sys/user/delete`,
        method: 'delete',
        params: data
    })
}
export function updateUser(data) {
    return request({
        url: '/acode/api/sys/user/update',
        method: 'post',
        data
    })
}
export function getUser(params) {
    return request({
        url: '/acode/api/sys/user/get',
        method: 'get',
        params
    })
}

export function downloadLog(data){
    return request({
        url: '/acode/api/log/export',
        method: 'post',
        data,
        responseType: 'blob'
    })
}